import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]资产
 */
export function queryFundAssetAllocationUsingPOST(
  req: InfoDateDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcAssetAllocation> {
  return resource.postNoAuth('/fundPosition/queryFundAssetAllocation', req, config);
}

/**
 * [No Auth]行业
 */
export function queryFundInvestIndustryUsingPOST(
  req: InfoDateDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcInvestIndustry> {
  return resource.postNoAuth('/fundPosition/queryFundInvestIndustry', req, config);
}

/**
 * [No Auth]重仓信息
 */
export function queryKeyPortfolioUsingPOST(
  req: InfoDateDto | void,
  config?: RequestConfig
): Promise<ApiResultKeyPortfolioDto> {
  return resource.postNoAuth('/fundPosition/queryKeyPortfolio', req, config);
}

/**
 * [No Auth]场内基金的重仓股列表
 */
export function queryKeyPortfolioExchangeUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultKeyPortfolioExchangeDto> {
  return resource.postNoAuth('/fundPosition/queryKeyPortfolioExchange', req, config);
}

/**
 * [No Auth]下拉的日期
 */
export function queryReportDateListUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcReportDateList> {
  return resource.postNoAuth('/fundPosition/queryReportDateList', req, config);
}
